import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';


const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./app.component').then((m) => m.AppComponent),
    children: [
      {
        path: '',
        loadChildren: () => import('./signpost/signpost.module').then((m) => m.SignpostModule),
        title: 'Choose a Nessy program'
      }
    ],
    title: 'Choose a Nessy program'
  },
  {
    path: 'error',
    loadComponent: () => import('./core/error/error.component').then((m) => m.ErrorComponent),
    title: 'Error'
  },
  {
    path: 'logout',
    loadComponent: () => import('./logout/logout.component').then((m) => m.LogoutComponent),
    title: 'Logout'
  },
  {
    path: 'readingspelling',
    loadComponent: () =>
      import('./games/reading-spelling/reading-spelling.component').then((m) => m.ReadingSpellingComponent),
    title: 'Reading and Spelling'
  },
  {
    path: 'hreading',
    loadComponent: () => import('./games/hairy-reading/hairy-reading.component').then((m) => m.HairyReadingComponent),
    title: 'H Reading'
  },
  {
    path: 'numbersense',
    loadComponent: () => import('./games/number-sense/number-sense.component').then((m) => m.NumberSenseComponent),
    title: 'Number Sense'
  },
  {
    path: 'nessyfingers',
    loadComponent: () => import('./games/nessy-fingers/nessy-fingers.component').then((m) => m.NessyFingersComponent),
    title: 'Nessy Fingers'
  },
  {
    path: 'jungletown',
    loadComponent: () => import('./games/jungle-town/jungle-town.component').then((m) => m.JungleTownComponent),
    title: 'Jungle Town'
  },
  {
    path: 'dyslexiaquest',
    loadComponent: () =>
      import('./games/dyslexia-quest/dyslexia-quest.component').then((m) => m.DyslexiaQuestComponent),
    title: 'Yeti Mountain'
  },
  {
    path: 'writingbeach',
    loadComponent: () => import('./games/writing-beach/writing-beach.component').then((m) => m.WritingBeachComponent),
    title: 'Writing Beach'
  },
  { path: '**', redirectTo: '', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
